import { isValidFeatureName } from '@starter/api/scratchpad';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { MockupHost } from '../scratchpad/mockup-host.tsx';

/**
 * A UI mockup rendered from a file on this branch — see docs/SCRATCHPAD.md.
 *
 * Outside the app's own surface on purpose: no session, no API calls, no
 * database. A mockup still renders when the rest of the stand does not, which
 * is most of why it is useful while a feature is still being argued about.
 */
function ScratchpadRoute() {
  const { feature } = Route.useParams();

  return <MockupHost feature={feature} />;
}

export const Route = createFileRoute('/scratchpad/$feature')({
  // The same predicate the API applies before it reads anything, so a name that
  // could never be served is a 404 here rather than a notice about a file that
  // was never addressable.
  beforeLoad: ({ params }) => {
    if (!isValidFeatureName(params.feature)) throw notFound();
  },
  component: ScratchpadRoute,
});
